import { useEffect, useId, useRef, useState } from 'react';

export function AlbumDescription({ text }: { text: string }) {
    const id = useId();
    const paragraph = useRef<HTMLParagraphElement>(null);
    const [expanded, setExpanded] = useState(false);
    const [overflows, setOverflows] = useState(false);

    useEffect(() => {
        const element = paragraph.current;
        if (!element) return;

        const measure = () => {
            const lineHeight = Number.parseFloat(getComputedStyle(element).lineHeight);
            setOverflows(element.scrollHeight > lineHeight * 3 + 1);
        };
        const observer = new ResizeObserver(measure);
        observer.observe(element);
        measure();
        return () => observer.disconnect();
    }, [text]);

    return (
        <div className="album-description">
            <p
                ref={paragraph}
                id={id}
                className="album-description__text"
                data-expanded={expanded}
            >
                {text}
            </p>
            {overflows ? (
                <button
                    type="button"
                    className="album-description__toggle"
                    aria-expanded={expanded}
                    aria-controls={id}
                    onClick={() => setExpanded((value) => !value)}
                >
                    {expanded ? 'Collapse' : '…expand'}
                </button>
            ) : null}
        </div>
    );
}
